<div id="top-el"></div>
<div class="wrapper wrapper__selfevaluation circumstance user-select-none clearfix"
     [ngStyle]="deviceInnerHeight > 0 ?
        {
            'min-height': deviceInnerHeight + 'px'
        } : ''"
>
    {{ error }}
    <div class="row se-progress-bar">
        <div class="col-sm-12">
            <self-evaluation-progressbar-component  *ngIf="itemsGroup.length"
                                                    [step]="currentStep"
                                                    [activePage]="activePage" [total]="itemsGroup.length">
            </self-evaluation-progressbar-component>
        </div>
    </div>
    <div class="row header-title">
        <div class="col-sm-12">
            <h1 class="wrapper__title wrapper__title--normal">{{ pageTypes[appService.SEType]['contentHeader'][currentStep] | translate}}</h1>
        </div>
    </div>
    <div class="feeling-block row" *ngFor="let group of itemsGroup; let groupIndex = index" [ngClass]="{'active':(groupIndex+1)==activePage}">
        <div class="col-sm-12" *ngFor="let item of group; let itemIndex = index">
            <div class="feeling-item" (click)="selectQuestion(item, item.is_smoke)"
                 [ngClass]="{'active':(item.is_smoke && selectedCircumstanceIds.indexOf(item.id) > -1) || (!item.is_smoke && selectedIds.indexOf(item.id) > -1)}">
                {{ item['name_' + lang] }}
            </div>
        </div>
    </div>
    <div class="row wrapper__btns circumstance__btns">
        <div class="col-sm-12 slide-navigator">
            <button [class.hidden]="groupSelectedCount[activePage]" *ngIf="!isLoading"
                    (click)="saveAndGoNextPage()"
                    type="submit"
                    class="btn btn-primary badge-pill pd-v--sm btn-xs-full">
                <i class="fas fa-angle-right fa-2x"></i>
                {{ 'None Applies to Me' | translate }}
            </button>
            <button [class.hidden]="!groupSelectedCount[activePage]"
                    *ngIf="!isLoading" (click)="saveAndGoNextPage()"
                    type="submit"
                    class="btn btn-primary badge-pill pd-v--sm btn-xs-full">
                <i class="fas fa-angle-right fa-2x"></i>
                {{ 'Next' | translate }}
            </button>
            <button (click)="openConfirm()"
                    type="submit"
                    class="btn btn-secondary pd-v--sm btn-xs-full text-regular">
                <i class="fas fa-clock"></i>
                {{ 'Continue later' | translate }}
            </button>
        </div>
    </div>
    <self-evaluation-confirm-modal-component #confirmModal
                                             [isStudy] = "isStudy"
                                             [isIntroducePage]="false"
                                             (confirmContinueLater)="continueLaterSubmit()">
    </self-evaluation-confirm-modal-component>
</div>
